import { render, staticRenderFns } from "./CancellationRequisition.vue?vue&type=template&id=d8d0774e&"
import script from "./CancellationRequisition.vue?vue&type=script&lang=js&"
export * from "./CancellationRequisition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports